export default {
  SwipedCards: 'my_orders_cards.swiped',
  RepeatClicked: 'my_orders_repeat.clicked',
  BasketCouchmarkLoaded: 'basket_coachmark.loaded',
  BasketClicked: 'basket.clicked',
  HelpClicked: 'online_help.clicked',
  LoadedPage: 'my_orders.loaded',
};

export const GTMEventParams = {
  SCREEN_NAME: 'my_orders',
  RECHARGE_TO: 'pedidosya',
};
